import React from "react";
import { useParams } from 'react-router-dom';
import { useEffect, useState } from "react";
import { Signature, ethers } from "ethers";
import WordsCloudFS from "../components/wordsCloudFS";


const WordsCloudFullScreen = () => {

    return(
        <div>
            <WordsCloudFS />
        </div>
    )
}
export default WordsCloudFullScreen;